// @flow
import { useTranslation } from 'react-i18next';

import { statuses, type Status } from '../../dataTypes/orderRequests/statuses';


const whichMap: { [Status]: string } = {
  [statuses.All]: 'order_requests_which_all',
  [statuses.WaitingForIssuance]: 'order_requests_which_waiting_for_issuance',
  [statuses.WaitingForSpend]: 'order_requests_which_waiting_for_spend',
  [statuses.Spent]: 'order_requests_which_spent',
  [statuses.OpenedRequest]: 'order_requests_which_opened_request',
  [statuses.WaitingForProcessing]: 'order_requests_which_waiting_for_processing',
  [statuses.Removed]: 'order_requests_which_removed',
};

export default function useEmptyWarn(status: Status): string {
  const { t } = useTranslation('cafeteria');

  const which = t(whichMap[status]);
  return t('order_requests_table_empty', { which });
}
